import { render, staticRenderFns } from "./ProDinningRoomDialog.vue?vue&type=template&id=0ba688c3&scoped=true"
import script from "./ProDinningRoomDialog.vue?vue&type=script&lang=js"
export * from "./ProDinningRoomDialog.vue?vue&type=script&lang=js"
import style0 from "./ProDinningRoomDialog.vue?vue&type=style&index=0&id=0ba688c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba688c3",
  null
  
)

export default component.exports